import moment from 'moment';
/*
*  对象键值排序
*   a > b > c
*/
export function sortObj(obj){
  let newkey = Object.keys(obj).sort((a,b)=>{
    return a.localeCompare(b,'zh-CN')
  });
  let newObj = {};
  for (let i = 0; i < newkey.length; i++) {//遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
    }
  return newObj;
}
/*
* 字符串get请求拼接
*/
export function encodeParams(obj) {
  const params = []
  Object.keys(obj).forEach((key) => {
    let value = obj[key]
    if (typeof value === 'undefined') {
      value = ''
    }
    params.push([key, value].join('='))
  })
  return params.join('&')
}

// export const store = {
//   set: () => {

//   },
//   get:(key) => {
//     return my.getStorageSync({ key }).data || {};
//   }
// }

export function times(time, date) {
  let t = moment(time || null).format(date);
  return t;
}

// 十位补零
export function pad (num) {
  return num < 10 ? '0' + num : num;
}

export function phoneType(u) {
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    return 1
  } else if (u.indexOf('iPhone') > -1) {
    return 2
  } else if (u.indexOf('Windows Phone') > -1) {//winphone手机
   return 0
  } else {
    return 0
  }
}